// extracted by mini-css-extract-plugin
export default {"ordersContainer":"ordered_ordersContainer__89vHF"};